module.exports = __webpack_public_path__ + "static/media/foto2.0e59a587.png";